import { combineReducers } from 'redux';
import authReducer from './authSlice';
import categoriesReducer from './categoriesSlice'
import collectionsSlice from './collectionsSlice';
import productTypesSlice from './productTypesSlice';
import colorsSlice from './colorsSlice';
import productTagsSlice from './productTagsSlice';
import taxClassSlice from './taxClassSlice';
import shippingMethodSlice from './shippingMethodSlice';
import warehouseSlice from './warehosueSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  categories: categoriesReducer,
  collections: collectionsSlice,
  productTypes: productTypesSlice,
  colors: colorsSlice,
  productTags: productTagsSlice,
  taxClass: taxClassSlice,
  shippingMethod: shippingMethodSlice,
  warehouse: warehouseSlice,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
